var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Map } from 'immutable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EntityView from "../EntityView";
import { Loader } from "../../components/Elements/Loader";
import { actions } from "../../BasicReducer";
import { PDFView } from "../PDFView";

class EntityViewerComponent extends Component {
  constructor(props, context) {
    super(props, context);
    props.setSidepanelTrigger();
  }

  render() {
    const { entity } = this.props;

    if (!entity.get('_id')) {
      return /*#__PURE__*/_jsx(Loader, {});
    }

    return entity.get('defaultDoc') ? /*#__PURE__*/React.createElement(PDFView, this.props) : /*#__PURE__*/React.createElement(EntityView, this.props);
  }
}






const setSidepanelTrigger = () => actions.set('library.sidepanel.view', 'entity');

const mapStateToProps = (state) => {
  const entity = state.documentViewer.doc.get('_id') ?
  state.documentViewer.doc :
  state.entityView.entity;

  return {
    entity
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setSidepanelTrigger
    },
    dispatch
  );
}

const ViewerComponent = connect(mapStateToProps, mapDispatchToProps)(EntityViewerComponent);

export { ViewerComponent };